export default "__VITE_ASSET__64f2fbc7__"